import { t } from '@luna/i18n';

export const getProductsCountFilterMessage = (productsCount?: number): string => {
    if (productsCount) {
        return t('search.searchFilters.products', { count: productsCount });
    }
    return '';
};
